import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/chatbot-data';

// Fallback to avoid crash during migration if env vars are missing
// Fallback to avoid crash during migration if env vars are missing or invalid
const envUrl = SUPABASE_URL?.trim();
const url = (envUrl && (envUrl.startsWith('http://') || envUrl.startsWith('https://')))
  ? envUrl
  : "https://placeholder.supabase.co";

const key = SUPABASE_ANON_KEY || "placeholder";

export const supabase = createClient<Database>(url, key, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});